import FormField, { TYPE, STYLE, SIZE } from "./FormField";

export { TYPE, STYLE, SIZE };

export default FormField;
